import React from 'react'
import PropTypes from 'prop-types'

import {
  UserAssignmentCheckbox,
  UserAssignmentSelect,
} from '../../../common/components/sections'
import { PERMISSIONS, USER_ASSIGNMENT_LABEL } from '../../../common/constants'

import { useUserHasPermissions } from '../../../account/hooks'
import { useAssignUserToBrandCurationTaskMutation } from '../../hooks'

const BrandCurationTaskUserAssignment = ({
  brandCurationTaskId,
  userActionType,
  otherAssignedUsers,
  assignedUser,
  isCheckbox,
}) => {
  const [assignUser] = useAssignUserToBrandCurationTaskMutation(
    brandCurationTaskId,
    userActionType,
  )

  const hasPermissionToAssignOtherUsers = useUserHasPermissions(
    PERMISSIONS.BRAND_CURATION_TASK.ASSIGN_USERS,
  )

  if (isCheckbox || !hasPermissionToAssignOtherUsers) {
    return (
      <UserAssignmentCheckbox
        assignedUser={assignedUser}
        onChange={assignUser}
        otherAssignedUsers={otherAssignedUsers}
        userActionType={userActionType}
        unassigendLabel={USER_ASSIGNMENT_LABEL[userActionType]}
      />
    )
  }

  return (
    <UserAssignmentSelect
      assignedUser={assignedUser}
      onChange={assignUser}
      otherAssignedUsers={otherAssignedUsers}
      userActionType={userActionType}
    />
  )
}

BrandCurationTaskUserAssignment.propTypes = {
  brandCurationTaskId: PropTypes.string.isRequired,
  userActionType: PropTypes.string.isRequired,
  otherAssignedUsers: PropTypes.arrayOf(PropTypes.object),
  assignedUser: PropTypes.object,
  isCheckbox: PropTypes.bool,
}

BrandCurationTaskUserAssignment.defaultProps = {
  assignedUser: undefined,
  otherAssignedUsers: [],
  isCheckbox: false,
}

export default BrandCurationTaskUserAssignment
